import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconActionBusiness } from '../../../../../assets/icons/svg/colored-icons/ic-colored-categorization-business.svg';
import { ReactComponent as IconActionPersonal } from '../../../../../assets/icons/svg/colored-icons/ic-colored-categorization-personal.svg';
import { ReactComponent as IconSplit } from '../../../../../assets/dashboard/action-split-icon.svg';
import { CircleWrapper } from './GenericComponents';
import { SmallLabel } from './SmallLabel';

interface ICategorizationActionsProps {
  className?: string;
  onBusinessActionClick: () => void;
  onPersonalActionClick: () => void;
  onSplitActionClick: () => void;
  isDisabled: boolean;
}

export const CategorizationBusinessActions = ({
  className, onBusinessActionClick, onPersonalActionClick, onSplitActionClick, isDisabled,
}: ICategorizationActionsProps) => {
  const { t } = useTranslation('dashboardFaceliftResourcesEN');
  const disabledClassName = isDisabled ? 'opacity-30' : '';
  return (
    <div className={`w-[206px] flex justify-between items-center relative z-30 px-[8px] mx-auto ${className}`}>
      <div className='relative h-full cursor-pointer' onClick={!isDisabled ? onPersonalActionClick : () => {}} tabIndex={0} onKeyDown={() => {}} role='button'>
        <CircleWrapper isButton className={`${disabledClassName} h-[56px] w-[56px]`}>
          <IconActionPersonal className={`${disabledClassName} relative`} data-testid='CategorizationBusinessActions__personal-icon' />
        </CircleWrapper>
        <SmallLabel label={t('CATEGORIZATION_ACTION_PERSONAL')} testId='CategorizationBusinessActions__action-personal' className='text-center mt-[5px]' />
      </div>
      <div className='relative cursor-pointer h-[56px]' onClick={!isDisabled ? onSplitActionClick : () => {}} tabIndex={0} onKeyDown={() => {}} role='button'>
        <CircleWrapper isButton className={`${disabledClassName} h-[34px] w-[34px]`}>
          <IconSplit className={`${disabledClassName}`} data-testid='CategorizationBusinessActions__split-icon' />
        </CircleWrapper>
      </div>
      <div className='relative h-full cursor-pointer' onClick={!isDisabled ? onBusinessActionClick : () => {}} tabIndex={0} onKeyDown={() => {}} role='button'>
        <CircleWrapper isButton className={`${disabledClassName} h-[56px] w-[56px]`}>
          <IconActionBusiness className={`${disabledClassName} relative`} data-testid='CategorizationBusinessActions__business-icon' />
        </CircleWrapper>
        <SmallLabel label={t('CATEGORIZATION_ACTION_BUSINESS')} testId='CategorizationBusinessActions__action-business' className='text-center mt-[5px]' />
      </div>
    </div>
  );
};
